export enum OsmPlaceType {
  // Administrative divisions
  CONTINENT = 'continent',
  COUNTRY = 'country',
  STATE = 'state',
  PROVINCE = 'province',
  DISTRICT = 'district',
  COUNTY = 'county',
  MUNICIPALITY = 'municipality',
  CITY = 'city',
  TOWN = 'town',
  VILLAGE = 'village',
  HAMLET = 'hamlet',
  SUBURB = 'suburb',
  LOCALITY = 'locality',
  ISLAND = 'island',
  STREET = 'street',

  // Buildings and infrastructure
  BUILDING = 'building',
  HOUSE = 'house',
  APARTMENTS = 'apartments',
  HOTEL = 'hotel',
  SCHOOL = 'school',
  UNIVERSITY = 'university',
  HOSPITAL = 'hospital',
  CHURCH = 'church',
  FIRE_STATION = 'fire_station',
  POLICE = 'police',

  // Natural features
  MOUNTAIN = 'mountain',
  HILL = 'hill',
  VOLCANO = 'volcano',
  LAKE = 'lake',
  RIVER = 'river',
  FOREST = 'forest',
  BEACH = 'beach',

  // Transportation infrastructure
  AERODROME = 'aerodrome',
  STATION = 'station',
  BUS_STATION = 'bus_station',
  TRAM_STOP = 'tram_stop',
  SUBWAY_ENTRANCE = 'subway_entrance',
  ROAD = 'road',
  RAILWAY = 'railway',
  BRIDGE = 'bridge',
  TUNNEL = 'tunnel',

  // Points of interest
  ATTRACTION = 'attraction',
  MONUMENT = 'monument',
  MUSEUM = 'museum',
  PARK = 'park',
  STADIUM = 'stadium',
  THEATRE = 'theatre',
  ZOO = 'zoo',

  // Facilities and services
  SHOP = 'shop',
  RESTAURANT = 'restaurant',
  CAFE = 'cafe',
  BAR = 'bar',
  LIBRARY = 'library',
  POST_OFFICE = 'post_office',
  BANK = 'bank',
  ATM = 'atm',
}
